import { ElementType } from '../../../common/elements/elementTypes';
import { getLocationPathname } from '../../app/routingSelector';
import { createAndEditElement } from '../../element/actions/elementActions';
import { createTaskList } from '../../element/taskList/taskListActions';
import { navigateToUrl } from '../../reducers/navigationActions';
import { getListChildNewLocation } from '../../../common/elements/utils/elementLocationUtils';
import { PlatformDetails } from '../../../common/platform/platformTypes';
import { isPlatformAndroid } from '../../platform/utils/platformDetailsUtils';
import { getCurrentUserQuickNotesRootBoardId } from '../../user/currentUserSelector';
import { Capacitor } from '@capacitor/core';
import { CAPACITOR_MN_KEYBOARD_PLUGIN, CAPACITOR_NAVIGATION_PLUGIN } from '../../../capacitor_plugins/pluginConstants';
import { NavigationPlugin } from '../../../capacitor_plugins/navigation';
import { KeyboardPlugin } from '../../../capacitor_plugins/keyboard';

const navigateToMobileQuickNotes = () => (dispatch: Function, getState: Function) => {
    const state = getState();
    const quicknotesBoardId = getCurrentUserQuickNotesRootBoardId(state);
    const pathname = getLocationPathname(state);

    if (!pathname.includes(quicknotesBoardId)) {
        dispatch(navigateToUrl(quicknotesBoardId));
        return;
    }

    if (Capacitor.isPluginAvailable(CAPACITOR_NAVIGATION_PLUGIN)) {
        NavigationPlugin.onQuicknotesNavigation();
    }
    // If already in quicknotes then scroll to the top and trigger listeners for quicknotes navigation
    document.getElementsByClassName('MobilePageBody').item(0)?.scrollTo(0, 0);
};

const getElementLocation = ({ boardId }: { boardId: string }) => getListChildNewLocation({ listId: boardId });

export const navigateToQuicknotes = () => async (dispatch: Function) => {
    dispatch(navigateToMobileQuickNotes());
};

export const createAndEditNewQuickNoteElement =
    (boardId: string, type: ElementType, platformDetails: PlatformDetails) => async (dispatch: Function) => {
        const location = getElementLocation({ boardId });
        switch (type) {
            case ElementType.TASK_LIST_TYPE:
                dispatch(
                    createTaskList({
                        boardId,
                        location,
                    }),
                );
                break;
            default:
                dispatch(
                    createAndEditElement({
                        elementType: type,
                        location,
                    }),
                );
        }

        // Android has a weird 'bug' where the keyboard won't show when focusing the element
        // This is likely due to restrictions around focus when the webview hasn't been
        // interacted with yet. As a workaround, we're manually triggering the keyboard to show
        // The delay is required to make sure the element has focus before the keyboard is triggered
        if (
            isPlatformAndroid(platformDetails) &&
            type !== ElementType.IMAGE_TYPE &&
            Capacitor.isPluginAvailable(CAPACITOR_MN_KEYBOARD_PLUGIN)
        ) {
            setTimeout(() => {
                KeyboardPlugin.show();
            }, 750);
        }
    };
